import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@dma/ui';
import { FeatureFlagProvider } from '@dma/shared';
import type { CompositionRoot } from './composition-root';
import { createRouter } from './router';

export interface AppProps {
  compositionRoot: CompositionRoot;
}

/**
 * Application root. Wires the Error Boundary, Feature Flag context, and
 * Router together using services resolved once in the Composition Root.
 * The router itself is built here (not imported as a static singleton)
 * because feature route loaders depend on composition-root use cases.
 */
export function App({ compositionRoot }: AppProps) {
  const router = createRouter(compositionRoot);

  return (
    <ErrorBoundary logger={compositionRoot.logger}>
      <FeatureFlagProvider flags={compositionRoot.flagProvider.getAll()}>
        <RouterProvider router={router} />
      </FeatureFlagProvider>
    </ErrorBoundary>
  );
}
